import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-dialog-partial-component',
    templateUrl: 'dialog-partial.component.html',
    standalone: true,
    imports: [MatDialogModule, MatDialogModule, MatButtonModule, MatButtonModule]
})
export class DialogPartialComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogPartialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
